import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Applications extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			APPLICATION_NAME: ''
		};
		
		var initialApplicationList = this.copyApplicationList();
		initialApplicationList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			applicationList: initialApplicationList,
			search: search,
			searchCount: null
		};
	}
	
	copyApplicationList() {
		var applicationListCopy = this.copyObject(applicationList);
		for (var i = 0; i < applicationList.columns.length; i++) {
			if (applicationList.columns[i].Header) {
				applicationListCopy.columns[i].Header = applicationList.columns[i].Header;
			}
			if (applicationList.columns[i].Cell) {
				applicationListCopy.columns[i].Cell = applicationList.columns[i].Cell;
			}
		}
		return applicationListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newApplicationList = this.copyApplicationList();
		newApplicationList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			applicationList: newApplicationList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.APPLICATION_NAME)) search.Children.push({ Attribute: 'APPLICATION_NAME', Operator: 'like', StringValue: '%' + data.APPLICATION_NAME + '%' });
		search.Children.push({ Attribute: 'DELETE_FLAG', Operator: 'is null' });
		
		return search;
	}
	
	addApplication() {
		this.props.navigate('/BuildingAccess/Applications/new');
	}
	
	editApplication(applicationId) {
		this.props.navigate('/BuildingAccess/Applications/' + applicationId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Applications',
			columns: exportColumns,
			entity: 'APPLICATION',
			search: this.constructSearch(this.state.search),
			order: 'APPLICATION_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Applications</span>
					<ChemEdit parent={this} columns={applicationSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_Applications' table={this.state.applicationList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='200px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const applicationSearch = [
	{ Header: 'Name', accessor: 'APPLICATION_NAME', row: 0, col: 0 }
];

const applicationList = {
	query: { entity: 'APPLICATION', search: null, order: 'APPLICATION_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addApplication()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editApplication(props.row.values.APPLICATION_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'APPLICATION_ID' },
		{ Header: 'Name', accessor: 'APPLICATION_NAME', width: 300 },
		{ Header: 'Schema', accessor: 'APPLICATION_SCHEMA', width: 300 },
		{ Header: 'Detail', accessor: 'APPLICATION_DETAIL', width: 300 },
		{ Header: 'Domain', accessor: 'DOMAIN', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'APPLICATION_ID', width: 5 },
	{ Header: 'Name', accessor: 'APPLICATION_NAME', width: 20 },
	{ Header: 'Schema', accessor: 'APPLICATION_SCHEMA', width: 20 },
	{ Header: 'Detail', accessor: 'APPLICATION_DETAIL', width: 20 },
	{ Header: 'Domain', accessor: 'DOMAIN', width: 10 }
];

export default withRouter(Applications);